import styled from 'styled-components';
import { BLACK, GRAYSCALE_500, NEUTRAL_100, PALE_BLUE, WHITE } from "@styles/colors";
import { GIVONIC, INTER } from "@styles/fonts";
import { safeAreaInset } from '@lib/telegram';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: ${PALE_BLUE};
  position: relative;
`;

export const RecoveryPhraseContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 12px;
  overflow-y: auto;
  height: 100%;
`;

export const BackgroundImageContainer = styled.div<{ $backgroundImage: string }>`
  background-image: url(${(props) => props.$backgroundImage});
  background-size: contain;
  background-position: right;
  background-repeat: no-repeat;
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${NEUTRAL_100};
  margin-top: 32px;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 24px 12px;
  background-color: ${WHITE};
  padding-bottom: ${safeAreaInset().bottom || 24}px;
`;

export const ImportantNotesContainer = styled.div`
  color: ${BLACK};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 16px;
  position: relative;
  height: 100%;
  overflow-y: auto;
`;

export const CircleBackgroundContainer = styled.div`
  position: absolute;
`;

export const Title = styled.span`
  font-family: ${GIVONIC.black};
  font-size: 24px;
  text-align: center;
  line-height: 24px;
  margin: 16px 0;
  z-index: 1000;
`;

export const NotesContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${INTER.regular};
  color: ${GRAYSCALE_500};
  gap: 24px;
  margin: 16px 0;
  padding: 0 16px 100px 16px;
  z-index: 1;
  overflow-y: auto;
`;

export const NoteItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const IconContainer = styled.div`
  border: 1px solid ${NEUTRAL_100};
  background-color: ${WHITE};
  border-radius: 100%;
  width: 42px;
  height: 42px;
  aspect-ratio: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const NoteText = styled.span`
  /* No additional styling needed as it inherits from parent */
`;

export const CheckboxContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 24px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  z-index: 1000;
  background-color: ${PALE_BLUE};
  padding-bottom: ${safeAreaInset().bottom || 24}px;
`;
